module.exports = __webpack_public_path__ + "static/media/ic_phone.ad0fa519.svg";